module.exports = __webpack_public_path__ + "img/2.bbd19e7d.svg";